export const googleTagManagerUtils = {
  pushAddToCartData(audiobookId, discountPrice, fbEventId) {
    if (discountPrice && discountPrice !== 'FREE') {
      const formattedPrice = discountPrice.replace('$', '').replace(' USD', '');
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add-to-cart-button-click',
        audiobookId,
        discountPrice: formattedPrice,
        fbEventId,
      });
    }
  },
};
